// extracted by mini-css-extract-plugin
module.exports = {"manualTagEntry":"manualTagEntry_manualTagEntry__39FJF"};